import { Component, EventEmitter, Output, Input } from '@angular/core';
import { ConfirmOutput } from '../../../shared/models/ConfirmOutput';
import { CPDialogResult } from '../../../shared/enums/CPDialogResult';
import { CRUDActions } from '../../../shared/enums/CRUDActions';
import { CommonFunctions } from '../../../shared/static/common-functions';
import { BaseMessageInfo } from '../../../shared/models/BaseMessageInfo';
import { GlobalsService } from '../../../shared/services/globals.service';

import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { BaseDQOIComponent } from '@app/cp/shared/base-components/base-dqoi.component';
import { GItem } from '../../../shared/models/GItem';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import * as _ from 'lodash';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BaseAppMComponent } from '../../../shared/base-components/base-app-m.component';
import { DQOIReferenceDataQuery } from '../../../dqoi/state/dqoi-reference-data.query';
import { JobTitlesBus } from '../../../shared/models/JobTitlesBus';
import { DomainService } from '../../services/domain.service';
import { DomainHeaderBus } from '../../models/DomainHeaderBus';
import { DomainDetBus } from '../../models/DomainDetBus';
import { NotificationSettings } from '@progress/kendo-angular-notification';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'domain-dialog',
    templateUrl: './domain-dialog.component.html',
    styleUrls: ['./domain-dialog.component.scss']
})
export class DomainDialogComponent extends BaseAppMComponent<JobTitlesBus, DomainService, null, null> {

    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, public svc_data: DomainService, qry_rd: DQOIReferenceDataQuery, ) {
        super(globals, featureFlagService, qry_rd);

    }
    public editForm: UntypedFormGroup;
    get referenceData(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }
    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };
    type : number;
    saving: boolean = false;
    active: boolean = false;
    data: any;
    gridData: JobTitlesBus[];
    domainData : DomainHeaderBus;
    action1: CRUDActions;
    techId: string;
    assignmentDateTime: Date;
    code: string;
    @Input() title: string;
    @Input() message: string;
    @Output() confirmation: EventEmitter<ConfirmOutput> = new EventEmitter<ConfirmOutput>();
    @Input() sublings: GItem[] =[];
    statusList: GItem[] = []
    hide() {
        this.active = false;
        this.data = null;
        this.title = null;
        this.message = null;
        this.action1 = CRUDActions.None;

    }
    ok() {
        this.save();
    }

    save() {
        let busObj: DomainDetBus = new DomainDetBus();
        busObj.name = this.editForm.controls["name"].value;
        busObj.id = this.editForm.controls["id"].value;
        busObj.co = this.editForm.controls["co"].value;
        busObj.isActive = this.editForm.controls["isActive"].value;
        busObj.bool1 = this.editForm.controls["bool1"].value;

        this.svc_data.saveDomainData(this.type, busObj).subscribe((data: BaseMessageInfo) => {
            if (data.saveError) {
                let notifySettings: NotificationSettings;
                this.globals.notifyError(data.messages[0].message, true, notifySettings);
                this.hide();
            } else {
                if (this.type == 1 && CommonFunctions.hasArrayElementValue(data.primaryReturn) && data.primaryId) {
                    BaseDQOIComponent._referenceData.addLocalWarehouse(data.primaryReturn[0]);
                }
                let result: ConfirmOutput = {
                    action: this.action1, dialogResult: CPDialogResult.ok, data: { refresh: true }, code: this.code
                }
                this.confirmation.emit(result);
                this.hide();
            }

        },
            err => { this.CallFailed(err) }
        );

    }

    CallFailed(err) {

        this.saveError(err)

    }
    cancel() {
        let result: ConfirmOutput = { action: this.action1, dialogResult: CPDialogResult.cancel, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    close() {
        let result: ConfirmOutput = { action: this.action1, dialogResult: CPDialogResult.close, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    public show(id: any) {
        this.type = id;
        this.createForm();
        this.active = true;
        this.svc_data.GetDomainData(id).subscribe(data => {
            this.domainData = _.cloneDeep(data);

        });
    }

    public selectionChange(value: any): void {
        if (value) {

            this.editForm.patchValue({
                isActive: value.isActive,
                bool1: value.bool1,
                name: value.name,
                id: value.id,
                co: value.co,
              });

        }
        else {

            this.editForm.patchValue({
                id: null,
                name: "",
                co: 1,
                isActive: true,
                bool1:null            });
        }

    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'id': new UntypedFormControl(''),
            'name': new UntypedFormControl('', Validators.required),
            'isActive': new UntypedFormControl(true),
            'bool1': new UntypedFormControl(null),
            'co': new UntypedFormControl(1),

            });}
}

